import type { SportsApi } from "@/v2/api/metadata/sports";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { notify, notifyApiError } from "@/v2/notifications/notify";
import { NXGDSStatusVariant } from "@nsftx/seven-nxg-design-system-backoffice";

export function createDeleteDialog(options: { sportsApi: SportsApi }): DialogConfig {
  const { sportsApi } = options;

  return {
    id: "delete-sport",
    title: "Delete sport",
    description: `Are you sure you want to delete this sport?`,
    layout: {
      type: "nxgds-dialog",
      actions: [
        { intent: "dismiss", label: "Cancel", variant: "secondary" },
        { intent: "submit", label: "Delete", variant: "danger" },
      ],
    },
    structure: {
      type: "flat",
      children: [],
    },
    api: {
      submit: async (_data, dialogCtx) => {
        try {
          await sportsApi.delete(dialogCtx.row?.id);
          notify({
            variant: NXGDSStatusVariant.Positive,
            text: `You have successfully deleted "${dialogCtx.row?.name}" sport.`,
          });
        } catch (error) {
          notifyApiError(error, `Unable to delete "${dialogCtx.row?.name}" sport.`);
        }
      },
    },
  };
}
